const rulerOptionsData = {
  bmi: {
    field: 'bmi',
    defaultNum: 24,
    min: 1,
    max: 60,
    oneGridValue: 0.1
  },
  weight: {
    field: 'weight',
    defaultNum: 60,
    min: 20,
    max: 200,
    oneGridValue: 0.1
  },
  waist: {
    field: 'waist',
    defaultNum: 70,
    min: 20,
    max: 200,
    oneGridValue: 0.1
  },
  bm: {
    //基础代谢
    field: 'bm',
    defaultNum: 1500,
    min: 600,
    max: 4000,
    oneGridValue: 10
  },
  bfr: {
    //体脂率
    field: 'bfr',
    defaultNum: 30,
    min: 1,
    max: 60,
    oneGridValue: 0.1
  },
  hip: {
    //臀围
    field: 'hip',
    defaultNum: 100,
    min: 20,
    max: 200,
    oneGridValue: 0.1
  },
  bust: {
    //胸围
    field: 'bust',
    defaultNum: 100,
    min: 20,
    max: 200,
    oneGridValue: 0.1
  },
  arm_l: {
    //左臂围
    field: 'arm_l',
    defaultNum: 50,
    min: 10,
    max: 100,
    oneGridValue: 0.1
  },
  arm_r: {
    //右臂围
    field: 'arm_r',
    defaultNum: 50,
    min: 10,
    max: 100,
    oneGridValue: 0.1
  },
  thigh_l: {
    //左大腿围
    field: 'thigh_l',
    defaultNum: 50,
    min: 10,
    max: 100,
    oneGridValue: 0.1
  },
  thigh_r: {
    //右大腿围
    field: 'thigh_r',
    defaultNum: 50,
    min: 10,
    max: 100,
    oneGridValue: 0.1
  },
  calf_l: {
    //左小腿围
    field: 'calf_l',
    defaultNum: 50,
    min: 10,
    max: 100,
    oneGridValue: 0.1
  },
  calf_r: {
    //右小腿围
    field: 'calf_r',
    defaultNum: 50,
    min: 10,
    max: 100,
    oneGridValue: 0.1
  }
}
export { rulerOptionsData }
